import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register service worker for PWA + notifications, then ask for push permission
import("./registerSW").then(async (m) => {
  m.registerServiceWorker();
  // Wait for the service worker to take control, then ask for push permission
  if (navigator.serviceWorker.controller) {
    import("./push").then((p) => p.enablePush().catch(() => {}));
  } else {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      import("./push").then((p) => p.enablePush().catch(() => {}));
    }, { once: true });
  }
});
